import React from "react";

import {
  PrimaryBlockType,
  primaryBlock,
  PrimaryBlockConfig,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  renderTertiaryBlock,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box } from "theme-ui";
import defaults from "../defaults.json";
import { LayoutProps } from "../types/prop-types";

export type ItemType = {
  icon: string;
  name: string;
  description: string;
  title: string;
  _index?: number;
} & PrimaryBlockType<LayoutProps>;

/** ServicesItem PrimaryCollection */
export const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Large,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockTheme: BlockTheme.light,
};

export const ContentCollectionItem = primaryBlock<ItemType>(
  { isInnerBlock: true, ...blockConfig },
  ({
    icon,
    name,
    title,
    description,
    _index,
    SecondaryBlock,
    TertiaryBlock,
  }: ItemType) => (
    <Variants.GridOddEven odd={!((_index ?? 0) % 2)} className="padding-global">
      <Box className="container-small">
        <Box className="padding-section-large">
          <Box className="text-align-center">
            <Box className="margin-bottom margin-small">
              <Variants.IconSmall icon={icon} />
            </Box>
            <Box className="margin-bottom margin-xsmall">
              <Box>{name}</Box>
            </Box>
            <Box className="margin-bottom margin-small">
              <Variants.Heading>{title}</Variants.Heading>
            </Box>
            <Variants.ParagraphMedium>{description}</Variants.ParagraphMedium>
            {renderSecondaryBlock(SecondaryBlock)}
            {renderTertiaryBlock(TertiaryBlock)}
          </Box>
        </Box>
      </Box>
    </Variants.GridOddEven>
  )
);

ContentCollectionItem.defaultProps = getDefaultProps<ItemType>({
  layoutProps: defaults.layoutProps,
  contentProps: defaults.contentProps.PrimaryBlocks[0],
});
